import dayjs from "dayjs";

// queryOption.variables 帶 startDate/endDate（月檢視）時，cache 裡的清單只涵蓋該本地日期窗口。
// mutation 更新 cache 前須用此判斷紀錄是否屬於這份被過濾的結果集，
// 否則窗口外的紀錄會被插進當前清單，讓別的月份的紀錄出現在月檢視裡。
export const isWithinQueryWindow = (date, { startDate, endDate } = {}) => {
  if (!startDate || !endDate) {
    return true;
  }

  const localDate = dayjs(Number(date)).format("YYYY-MM-DD");
  return localDate >= startDate && localDate <= endDate;
};

// 每日 section 標頭用：把單日 spending 依「收入/支出」拆流，各自再依幣別加總。
// 以 Map 累加保留幣別首次出現順序，讓輸出順序穩定、可測。
export const summarizeByCurrency = (dateSpendings = []) => {
  const expenseMap = new Map();
  const incomeMap = new Map();

  dateSpendings.forEach(({ amount, category, currency }) => {
    const map = category && category.type === "income" ? incomeMap : expenseMap;
    const key = currency.name;
    map.set(key, (map.get(key) || 0) + amount);
  });

  const toList = (map) => Array.from(map, ([currency, total]) => ({ currency, total }));

  return {
    expenses: toList(expenseMap),
    incomes: toList(incomeMap),
  };
};

// 金額千分位格式化（標頭彙總用）。
export const formatAmount = (amount) => Number(amount).toLocaleString();

// epoch-ms 字串 → 中文星期幾。刻意用手動對照表，避免為單一字串全域引入 dayjs locale。
const WEEKDAYS = ["週日", "週一", "週二", "週三", "週四", "週五", "週六"];
export const weekdayLabel = (date) => WEEKDAYS[dayjs(Number(date)).day()];

export const popSpending = (spendings, newSpending) => {
  const index = spendings.findIndex((spending) => spending.id === newSpending.id);

  // findIndex 回傳 -1 時 splice(-1, 1) 會誤刪最後一筆
  if (index !== -1) {
    spendings.splice(index, 1);
  }
};

export const insertSpending = (spendings, newSpending) => {
  const spendingsLength = spendings.length;
  const lastSpending = spendings[spendingsLength - 1];
  const newSpendingDate = Number(newSpending.date);

  if (spendings.length === 0 || newSpendingDate <= Number(lastSpending.date)) {
    spendings.push(newSpending);
    return;
  }

  for (let i = 0; i < spendingsLength; i += 1) {
    const spending = spendings[i];

    if (newSpendingDate > Number(spending.date)) {
      spendings.splice(i, 0, newSpending);
      break;
    }
  }
};
